import http from "./http-service";
import { PROMO, PROMO_APPLY, REGISTRATION_CODES, VALIDATE_REGISTRATION_CODE } from "./endpoint-urls";
import { IPromoCode, IPromoCodeBody, IPromoValidateDTO, IPromoValidateResponse, IRegistrationCode, IRegistrationCodeBody, IRegistrationCodeValidateResponse } from "interfaces/BaseInterface";

const extractData = <T,>(res: { data: T }) => res.data;

export const getPromoCodes = () =>
  http.get<IPromoCode[]>(PROMO).then(extractData);

export const addPromoCode = (body: IPromoCodeBody) =>
  http.post<IPromoCode>(PROMO, body).then(extractData);

export const deletePromoCode = (id: string) =>
  http.delete<void>(`${PROMO}/${id}`).then(extractData);

export const validatePromoCode = (body: IPromoValidateDTO) =>
  http.post<IPromoValidateResponse>(PROMO_APPLY, body).then(extractData);

export const getRegistrationCodes = () =>
  http.get<IRegistrationCode[]>(REGISTRATION_CODES).then(extractData);

export const addRegistrationCode = (body: IRegistrationCodeBody) =>
  http.post<IRegistrationCode>(REGISTRATION_CODES, body).then(extractData);

export const deleteRegistrationCode = (id: string) =>
  http.delete<void>(`${REGISTRATION_CODES}/${id}`).then(extractData);

export const updateRegistrationCode = (id: string, body: IRegistrationCodeBody) =>
  http.put<IRegistrationCode>(`${REGISTRATION_CODES}/${id}`, body).then(extractData);

export const validateRegistrationCode = (body: { code: string }, silent = false) =>
  http.post<IRegistrationCodeValidateResponse>(VALIDATE_REGISTRATION_CODE, body, { _silent: silent } as any).then(extractData);
